import { useCurrentStateAndParams } from "@uirouter/react";

import { WEBSITE_ANALYSIS_MARKETING_KEYWORDS } from "app/pages/sales-intelligence/constants/routes";
import { SI_SEARCH_ROUTES } from "app/common/constants/ad-intelligence-routes";
import { ROUTES } from "single-spa/react-app/config/solutions25/adIntelligence/searchAdvertising/searchAdvertisingConstants";

export interface IWebsiteKeywordsEndpoints {
    table: string;
    excel: string;
    presetsTotal: string;
    trafficShare: string;
    drillDownTable: string;
    clicksOverTimeTrend: string;
}

export const keywordResearchEndpoints: IWebsiteKeywordsEndpoints = {
    table: "/widgetApi/WebsiteAnalysisV2/WebsiteAnalysis/Table",
    excel: "/widgetApi/WebsiteAnalysisV2/WebsiteAnalysis/Excel",
    presetsTotal: "/widgetApi/WebsiteAnalysisV2/WebsiteAnalysis/PresetsTotal",
    trafficShare: "/widgetApi/WebsiteAnalysisV2/WebsiteAnalysis/TrafficShare",
    drillDownTable: "/api/KeywordAnalysis/Pages/DrillDownTable",
    clicksOverTimeTrend: "/api/keywordAnalysis/keywords/clicksOverTime/Trend",
};

export const searchAdvertisingEndpoints: IWebsiteKeywordsEndpoints = {
    table: "/widgetApi/AdIntelligence/Search/WebsiteAnalysis/Table",
    excel: "/widgetApi/AdIntelligence/Search/WebsiteAnalysis/Excel",
    presetsTotal: "/widgetApi/AdIntelligence/Search/WebsiteAnalysis/PresetsTotal",
    trafficShare: "/widgetApi/AdIntelligence/Search/WebsiteAnalysis/TrafficShare",
    drillDownTable: "/api/AdIntelligence/Search/Pages/DrillDownTable",
    clicksOverTimeTrend: "/api/AdIntelligence/Search/clicksOverTime/Trend",
};

const websiteKeywordsEndpointsMap: Record<string, IWebsiteKeywordsEndpoints> = {
    organicsearch_websites_v2_traffic_keywords: keywordResearchEndpoints,
    search_website_topics: keywordResearchEndpoints,
    [WEBSITE_ANALYSIS_MARKETING_KEYWORDS]: keywordResearchEndpoints,
    [ROUTES.keywords]: searchAdvertisingEndpoints,
    [ROUTES.topics]: searchAdvertisingEndpoints,
    // Sales Intelligence mirror of Search Advertising.
    [SI_SEARCH_ROUTES.keywords]: searchAdvertisingEndpoints,
    [SI_SEARCH_ROUTES.topics]: searchAdvertisingEndpoints,
};

export const useWebsiteKeywordsEndpoints = (): IWebsiteKeywordsEndpoints => {
    const { state } = useCurrentStateAndParams();
    const endpoints = websiteKeywordsEndpointsMap[state.name];

    if (!endpoints) {
        throw new Error(
            `No endpoints configured for Website Keywords state: ${state.name}. ` +
                `Available states: ${Object.keys(websiteKeywordsEndpointsMap).join(", ")}`,
        );
    }

    return endpoints;
};
